import * as React from 'react';

import { type VariantProps, cva } from 'class-variance-authority';

import { cn } from '../lib';

const badgeVariants = cva(
  'inline-flex items-center rounded-full px-3 py-2 text-base uppercase leading-5 font-medium text-base-500',
  {
    variants: {
      variant: {
        default: 'bg-base-300',
        'base-100': 'bg-base-100',
      },
    },
    defaultVariants: {
      variant: 'default',
    },
  },
);

interface BadgeProps
  extends React.HTMLAttributes<HTMLDivElement>,
    VariantProps<typeof badgeVariants> {}

function Badge({ className, variant, ...props }: BadgeProps) {
  return (
    <div className={cn(badgeVariants({ variant }), className)} {...props} />
  );
}

export { Badge };
